import React, { useState } from 'react';

import { IconButton, InputAdornment, TextField } from '@mui/material';

import { ReactComponent as CloseIcon } from '../../../../common/assets/icons/close_icon.svg';
import { ReactComponent as SearchIcon } from '../../../../common/assets/icons/search_icon_small_gray.svg';

type Props = {
  clinicNotes: boolean;
  value: string;
  onChange: (searchTerms: string) => void;
};

const NoteSearchTermFilter: React.FC<Props> = ({
  clinicNotes,
  value,
  onChange,
}) => {
  const [searchValue, setSearchValue] = useState(value);

  const handleTappedClear = () => {
    if (searchValue.length > 0) {
      onChange('');
    }
    setSearchValue('');
  };

  const handleSearchInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSearchValue(event.target.value);
  };

  const onKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.code === 'Enter') {
      onChange(searchValue);
    }
  };

  return (
    <TextField
      placeholder={clinicNotes ? 'Search clinic notes' : 'Search op notes'}
      size='small'
      color='secondary'
      onKeyUp={onKeyUp}
      value={searchValue}
      onChange={handleSearchInputChange}
      sx={{
        width: { xs: '100%', sm: '232px' },
      }}
      InputProps={{
        style: {
          minHeight: 40,
          borderBlockColor: 'primary',
          backgroundColor: 'white',
          borderRadius: '40px',
        },
        startAdornment: (
          <InputAdornment position='start'>
            <SearchIcon />
          </InputAdornment>
        ),
        endAdornment:
          searchValue.length !== 0 ? (
            <>
              <InputAdornment
                sx={{ alignSelf: 'flex-start', mt: '20px', mr: '-8px' }}
                position='end'
              >
                <IconButton onClick={() => handleTappedClear()}>
                  <CloseIcon />
                </IconButton>
              </InputAdornment>
            </>
          ) : undefined,
      }}
    />
  );
};

export default NoteSearchTermFilter;
